<template>
    <Modal class="timezone-error-modal"
           icon="fa-triangle-exclamation"
           title="CLOCK.TIME_ERROR_MODAL_TITLE">
        <div v-if="rechecking"
             class="text-center">
            <PageLoadingSpinner />
        </div>
        <div v-else
             class="text-center">
            <div class="alert alert-danger text-base-size">
                {{ l('CLOCK.TIMEZONE_ERROR_MSG_1') }}
            </div>

            <div class="flex--desktop mb-1">
                <div class="flex--grow flex--shrink flex--basis-1-percent">
                    <p>
                        <small>
                            <i class="fa-regular fa-clock fa-fw"></i>
                            {{ l('CLOCK.TIMEZONE_ERROR_BRANCH_TIMEZONE') }}
                        </small>
                    </p>
                    <p class="text-lg">
                        <strong>
                            {{ branchTimezoneName }}
                        </strong>
                    </p>
                </div>

                <div class="flex--grow flex--shrink flex--basis-1-percent">
                    <p>
                        <small>
                            <i class="fa-regular fa-cash-register fa-fw"></i>
                            {{ l('CLOCK.TIMEZONE_ERROR_SYSTEM_TIMEZONE') }}
                        </small>
                    </p>
                    <p class="text-lg text-danger">
                        <strong @click.alt.prevent="bypassModal">
                            {{ systemTimezoneName }}
                        </strong>
                    </p>
                </div>
            </div>

            <p class="text-base-size">
                {{ l('CLOCK.TIMEZONE_ERROR_MSG_2') }}
            </p>

            <h5 v-if="currentDeviceID"
                class="mb-0">
                <small>{{ l('ABOUT.DEVICE_ID') }}: {{ currentDeviceID }}</small>
            </h5>
        </div>

        <template v-slot:footer>
            <div class="modl-footer">
                <SquareBtn color="danger"
                           size="lg"
                           class="cancel-btn"
                           @click="logout">
                    <i class="fa-solid fa-arrow-right-from-bracket fa-fw"></i> {{ l('LOGOUT') }}
                </SquareBtn>
                <OrderBranchSelector :show-name="false" />
                <SquareBtn color="default"
                           size="lg"
                           @click="sync">
                    <i class="fa-solid fa-sync"></i> {{ l('SYNC') }}
                </SquareBtn>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import OrderBranchSelector from '@/vue/components/Branches/OrderBranchSelector';
import PageLoadingSpinner from '@/vue/components/PageLoadingSpinner';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    name: 'TimezoneErrorModal',

    components: {
        Modal,
        SquareBtn,
        PageLoadingSpinner,
        OrderBranchSelector,
    },
    mixins: [
        ModalPropsMixin,
    ],

    props: {
        branchTimezoneName: {
            type: String,
            default: null,
        },
        systemTimezoneName: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            currentDeviceID: container.currentDevice.getDeviceId(),
            rechecking: false,
        };
    },

    methods: {
        async sync() {
            container.toastFactory.spinner('SYNC.STARTING');
            await container.syncedDataManager.clearData();

            setTimeout(() => {
                window.location.reload();
            }, 100);
        },

        logout() {
            container.userService.logout();
        },

        /**
         * You can hold and and click on the system timezone name displayed on the right as a secret way to
         * bypass the modal. It will not reappear until ProPoint is reloaded.
         */
        bypassModal() {
            this.resolve();
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../less/variables";

@media (max-width: @mobile-max) {
    .timezone-error-modal {
        .order-branch-selector {
            width: 100%;

            .branch-selector {
                .btn {
                    .text {
                        flex-grow: 0;
                    }
                }
            }
        }
    }
}
</style>
